import React from 'react';
import { Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFilter } from '@fortawesome/free-solid-svg-icons';
import './CustomerTableFilterButton.scss';

// Filter button component
interface FilterButtonProps {
    onFilterClick: () => void;
}

export const CustomerTableFilterButton: React.FC<FilterButtonProps> = ({ onFilterClick }) => {
    return (
        <div className="filter-button-container">
            <Button variant="secondary" className="button-cancel" onClick={onFilterClick}>
                <FontAwesomeIcon icon={faFilter} /> Filtrera
            </Button>
        </div>
    );
};

export default CustomerTableFilterButton;
